import React, { Component } from 'react';
import { Collapse, Container, Navbar, NavbarBrand, NavbarToggler, NavItem, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import { LoginMenu } from './api-authorization/LoginMenu';
import './NavMenu.css';
//import TopBar from './layout/TopBar';
//import './layout/TopBar.css';

export class NavMenu extends Component {
    static displayName = NavMenu.name;

    constructor(props) {
        super(props);

        this.toggleNavbar = this.toggleNavbar.bind(this);
        this.state = {
            collapsed: true
        };
    }

    toggleNavbar() {
        this.setState({
            collapsed: !this.state.collapsed
        });
    }

    render() {
        return (
            <header>
                <Navbar className="navbar-expand-sm navbar-toggleable-sm ng-white" light>
                    <Container>
                        <div className="row" style={{width: '100%'}}>
                            <div className="col"></div>
                            <div className="col" style={{ textAlign: 'center' }}>
                                <NavbarBrand tag={Link} to="/" style={{ marginRight: '0.0rem' }}>
                                    <img src="/images/ticlogo.jpg" style={{ height: '80px', marginLeft: '12px', marginRight: '12px' }} />
                                </NavbarBrand>
                                <span style={{ marginLeft: '12px', marginRight: '12px' }}>(314)-432-3633 <a href="mailto:ticms@ticms.com">ticms@ticms.com</a></span>
                            </div>
                            <div className="col">
                                <NavbarToggler onClick={this.toggleNavbar} className="mr-2" />
                                <Collapse className="d-sm-inline-flex flex-sm-row-reverse" isOpen={!this.state.collapsed} navbar>
                                    <ul className="navbar-nav flex-grow">
                                        <LoginMenu>
                                        </LoginMenu>
                                    </ul>
                                </Collapse>
                                {/*<div className="d-sm-inline-flex flex-sm-row-reverse collapse navbar-collapse">*/}
                                {/*    <NavLink style={{fontWeight: 'bold'}}>Customer Service</NavLink>*/}
                                {/*</div>*/}
                            </div>
                        </div>
                    </Container>
                </Navbar>
                {/*<div className="container" style={{ width: '100%' }}>*/}
                {/*    <TopBar />*/}
                {/*</div>*/}
            </header>
        );
    }
}
